// Draft prices are absolute amounts. The API keeps per-choice adjustments for
// compatibility with existing carts and server-authoritative order pricing.
export const hydrateProductOptions = (options, basePrice) =>
  (Array.isArray(options) ? options : []).map((option) => ({
    ...option,
    label: option.label || option.fieldKey,
    choices: (option.choices || []).map((choice) => ({
      ...choice,
      unitPrice: Number(basePrice || 0) + Number(choice.priceDelta || 0),
    })),
  }));

export const serialiseProductOptions = (options, basePrice, priceOnRequest = false) => {
  const keys = new Set();
  return (options || []).map((option) => {
    const fieldKey = String(option.fieldKey || "").trim();
    const label = String(option.label || fieldKey).trim();
    if (!fieldKey || !label || keys.has(fieldKey)) throw new Error("Each customer choice needs a unique name.");
    keys.add(fieldKey);
    if (!option.choices?.length) throw new Error(`Add at least one choice for ${label}, or remove it.`);
    const values = new Set();
    const choices = option.choices.map((choice) => {
      const value = String(choice.value || "").trim();
      if (!value || values.has(value)) throw new Error(`${label}: enter a unique name for every size or choice.`);
      values.add(value);
      const raw = choice.unitPrice ?? (Number(basePrice || 0) + Number(choice.priceDelta || 0));
      const price = Number(raw);
      if (!priceOnRequest && (raw === "" || !Number.isFinite(price) || price <= 0)) {
        throw new Error(`${label}: enter a price above zero for ${value}.`);
      }
      return {
        value,
        priceDelta: priceOnRequest ? 0 : price - Number(basePrice || 0),
        ...(choice.skuSuffix ? { skuSuffix: String(choice.skuSuffix).trim() } : {}),
      };
    });
    return { fieldKey, label, required: option.required !== false, choices };
  });
};
